enum ThemeEnum{
    light  = 'light',
    dark = 'dark'
}
export default ThemeEnum